import { cubicEaseOut } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { ButtonReset } from '@helpers/global';
import styled from 'styled-components';
const Container = styled.section `
  --accentColor: ${brand.primary.orange};
  --bgColor: ${brand.white};
  --fgColor: ${brand.white};

  display: flex;
  align-items: center;
  gap: 32px;

  &[data-alt-theme='true'] {
    --bgColor: ${brand.primary.blue};
    --fgColor: ${brand.primary.blue};
  }
`;
const ProgressWrapper = styled.div `
  display: grid;
  align-items: center;
  flex: 1 1 auto;
  height: 30px;
`;
const Progress = styled.div `
  position: relative;
  border-radius: 5px;
  grid-column: 1;
  grid-row: 1;
  height: ${fluid(6, 8)};
  overflow: hidden;
  width: 100%;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    display: block;
    background-color: var(--bgColor);
    border-radius: 2px;
    height: 4px;
    transform: translateY(-50%);
    width: 100%;
  }

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    display: block;
    background-color: var(--accentColor);
    height: 8px;
    transform: translateY(-50%) scaleX(var(--progress));
    transform-origin: center left;
    transition: transform 0.35s ${cubicEaseOut};
    width: 100%;
  }
`;
const List = styled.ul `
  position: relative;
  display: flex;
  grid-column: 1;
  grid-row: 1;
  height: 100%;
  z-index: 1;
`;
const Item = styled.li `
  display: block;
  flex: 1 1 calc(100% / var(--count));
`;
const Button = styled.button `
  ${ButtonReset}

  display: block;
  height: 100%;
  width: 100%;

  &:focus-visible {
    outline: 2px solid var(--accentColor);
  }
`;
const ControlsWrapper = styled.div `
  display: flex;
  gap: ${fluid(6, 8)};
`;
const ControlButton = styled.button `
  ${ButtonReset}

  display: flex;
  border: 1px solid var(--fgColor);
  border-radius: 50%;
  flex: 0 0 30px;
  height: 30px;
  place-content: center;
  place-items: center;
  width: 30px;

  svg {
    display: block;
    color: var(--fgColor);
    height: 13px;
    width: 13px;
  }

  &:focus-visible {
    outline: 2px solid var(--accentColor);
    outline-offset: 2px;
  }

  &.focus-ring,
  &:hover {
    border-color: var(--accentColor);
    transition: border-color 0.35s ${cubicEaseOut};

    svg {
      color: var(--accentColor);
      transition: color 0.35s ${cubicEaseOut};
    }
  }
`;
const PaginationStyles = {
    Button,
    Container,
    ControlButton,
    ControlsWrapper,
    Item,
    List,
    Progress,
    ProgressWrapper,
};
export default PaginationStyles;
